module.exports = __webpack_public_path__ + "GP.svg?497d4c6c32c8e2c0e135f911dbc7f180";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/GP.svg
// module id = 60
// module chunks = 0